import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { CrmTranslatePipe } from '@touch4it/ng-swp/translate';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { UpperCasePipe } from '@angular/common';
import { catchError, EMPTY, finalize } from 'rxjs';

import { CardExtraHandler } from '~/shared/components/card-extra/card-extra.handler';

@Component({
  selector: 'app-card-extra',
  template: `
    @switch (handler.mode()) {
      @case ('edit') {
        <button nz-button nzType="link" nzSize="small" (click)="handler.reset()" [disabled]="isLoading()">
          {{ 'generic.cancel' | crmTranslate | uppercase }}
        </button>
        <button nz-button nzType="primary" nzSize="small" (click)="save()" [nzLoading]="isLoading()">
          {{ 'generic.save' | crmTranslate | uppercase }}
        </button>
      }

      @default {
        <button nz-button nzType="link" nzSize="small" (click)="handler.mode.set('edit')">
          {{ 'generic.edit' | crmTranslate | uppercase }}
        </button>
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzButtonComponent, CrmTranslatePipe, UpperCasePipe],
})
export class CardExtraComponent<Result> {
  readonly handler!: CardExtraHandler<Result>;
  readonly isLoading = signal(false);

  protected save() {
    this.isLoading.set(true);
    this.handler
      .save()
      .pipe(
        catchError(() => EMPTY),
        finalize(() => this.isLoading.set(false)),
      )
      .subscribe();
  }
}
